export const HeaderConstants = Object.freeze({
    /** Header bell unread-count refresh cadence. */
    UNREAD_POLL_INTERVAL_MS: 60000,
    /** Counts above this render as "99+". */
    UNREAD_BADGE_MAX: 99,
    /** How many notifications the bell menu summarizes. */
    NOTIFICATIONS_MENU_SIZE: 5,
});

export default HeaderConstants;
